import { applicationsPath } from 'app/constants';
import { QueryKeys, useDeleteApp } from 'data';
import DeleteModal, { IDeleteModalProps } from '../delete-modal';

export const ApplicationDeleteModal = ({ entityName, onClose, onSettled }: IDeleteModalProps) => {
  const { mutate: deleteApp, isLoading: isAppDeleting } = useDeleteApp();

  return (
    <DeleteModal
      title="Remove application?"
      modalText={`Are you sure you want to remove ${entityName} ?`}
      entityName={entityName}
      successMessage={
        <div>
          Application <strong>{entityName}</strong> was removed
        </div>
      }
      redirectPath={applicationsPath}
      queryKey={QueryKeys.APPLICATIONS}
      deleteMethod={deleteApp}
      onClose={onClose}
      onSettled={onSettled}
      isLoading={isAppDeleting}
    />
  );
};
